import * as React from 'react';

export const WithdrawalDateTime = ({ dateTime, styleName = undefined, className = undefined }) => (
    <span className={className}>{dateTime.format('YYYY/MM/DD HH:mm')}</span>
);

export const WithdrawalDateTimeWithDow = ({ dateTime, styleName = undefined, className = undefined }) => (
    <span className={className}>{dateTime.format('YYYY/MM/DD(ddd) HH:mm')}</span>
);
